import { render, staticRenderFns } from "./DormRoomPanelCard.vue?vue&type=template&id=f279643a&scoped=true&"
import script from "./DormRoomPanelCard.vue?vue&type=script&lang=js&"
export * from "./DormRoomPanelCard.vue?vue&type=script&lang=js&"
import style0 from "./DormRoomPanelCard.vue?vue&type=style&index=0&id=f279643a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f279643a",
  null
  
)

export default component.exports